<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="5" style="padding: 5px">
        <!-- <el-button type="success" size="mini" icon="el-icon-arrow-left" @click="goBack"
          style="background-color:#008A2C">返回个人中心
        </el-button> -->
        <div @click="goBack" style="cursor: pointer; color: #008a2c">
          <el-button
            type="info"
            style="background-color: #008a2c"
            icon="el-icon-back"
            circle
          ></el-button>
          &nbsp;返回个人中心
        </div>
      </el-col>
      <el-col :span="19">
       
      </el-col>
    </el-row>
    <div class="f20 tc" style="margin-bottom: 10px;">武汉工商学院通讯录</div>
    <el-row :gutter="10">
      <el-col :span="9" style="padding: 5px; min-height: 430px">
        <el-input placeholder="搜索成员、部门" v-model="filterText"> </el-input>

        <el-tree
          style="background: #f5f5f5"
          class="filter-tree"
          :data="treeData"
          :props="defaultProps"
          highlight-current
          icon-class="el-icon-folder"
          empty-text="暂无数据"
          :filter-node-method="filterNode"
          @node-click="getUserByDeptId"
          ref="tree"
          node-key="id"
          :default-expanded-keys="[1]"
        >
        </el-tree>
        <div
          v-if="treeData[0].children.length == 0"
          style="height: 450px"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
        ></div>
      </el-col>
      <el-col :span="15">
        <el-table
          stripe
          :data="tableData"
          style="width: 100%; min-height: 500px"
        >
          <el-table-column prop="userid" label="账号" align="center">
          </el-table-column>
          <el-table-column prop="name" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="department" label="部门" align="center">{{
            isClickDepart
          }}</el-table-column>
          <el-table-column
            prop="position"
            label="职务"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column prop="mobile" label="手机" align="center">
          </el-table-column>
          <el-table-column prop="email" label="邮箱" align="center">
          </el-table-column>
        </el-table>

        <el-pagination
          style="margin: 20px"
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryDeptList, queryUserByDeptId } from "@/api/mailList.js";
export default {
  name: "mailList2",
  data() {
    return {
      loading: true,
      filterText: "",
      isClickDepart: "",
      treeData: [
        {
          id: 1,
          name: "武汉工商学院",
          children: [],
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
      tableData: [], //一页用户信息数据
      userData: [], //所有用户信息
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      data: [],
    };
  },
  mounted() {
    this.getDeptList();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  methods: {
    // async loadNode(node, resolve) {
    //   if (node.level === 0) {
    //       return resolve([{ id: 1, name: '武汉工商学院' }]);
    //     }
    //  //加载第一级节点
    //     if (node.level === 1) {
    //       const res = await queryDeptList(1)
    //       return resolve(res);
    //     }
    //     if(node.level> 1){
    //     console.log(node.data.id);
    //       const data =await queryDeptList(node.data.id)
    //       return resolve(data); // 加上这个，防止在该节点没有子节点时一直转圈的问题发生。
    //     }
    //       return resolve([]);
    // },
    // 查询部门列表
    async getDeptList() {
      const data = await queryDeptList();
      this.data = data;
      this.treeData[0].children = data;
      this.loading = false;
      // console.log("部门:", data)
    },
    // 根据部门id 查用户
    async getUserByDeptId(nodedata) {
      this.pageIndex = 1;
      this.isClickDepart = nodedata.name;
      const data = await queryUserByDeptId(nodedata.id);
      this.userData = data.userlist;
      this.total = data.userlist.length;
      this.handleCurrentChange(1);
    },
    goBack() {
      this.$router.push("/userCenter");
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 分页查询
    handleCurrentChange(val) {
      console.log(val);
      this.pageIndex = val;
      let start = (this.pageIndex - 1) * this.pageSize;
      let end = (this.pageIndex - 1) * this.pageSize + 10;
      if (end > this.total) {
        end = start + (this.total % 10);
      }
      this.tableData = this.userData.slice(start, end);
    },
  },
};
</script>
<style>
/* .el-tree-node > .el-tree-node__children {
  overflow-x: scroll;
} */
</style>
